import React from 'react';
import { ReactComponent as Logo } from '../../assets/Logo.svg';

const LandingPage = () => {
    return (
        <div>
            <nav style={{
                position: 'fixed',
                top: 0,
                padding: '20px 30px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: 'calc(100% - 60px)',
                zIndex: 1000,
                backgroundColor: 'black'
            }}>
                <div style={{ height: '40px' }}>
                    <Logo />
                </div>
                <div style={{ display: 'flex', gap: '32px' }}>
                    <p style={{
                        color: 'white',
                        fontSize: '18px',
                        fontWeight: '500',
                        lineHeight: '1.6rem'
                    }}>About</p>
                    <p style={{
                        color: 'white',
                        fontSize: '18px',
                        fontWeight: '500',
                        lineHeight: '1.6rem'
                    }}>Contact us</p>
                </div>
                <div>
                    <button style={{
                        backgroundColor: 'rgb(67, 175, 255)',
                        padding: '12px 24px',
                        borderRadius: '999px',
                    }}>
                        <p style={{
                            fontSize: '18px',
                            fontWeight: '500',
                            lineHeight: '1.6rem'
                        }}>Schedule a demo</p>
                    </button>
                </div>
            </nav>
        </div>
    );
};

export default LandingPage;